export enum CompanyFinancialsBalanceSheetBlock {
  Root = 'CompanyFinancialsBalanceSheet',
}

export enum CompanyFinancialsBalanceSheetElement {
  Item = 'item',
}
